import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Earn from './pages/Earn';
import CaseDetail from './components/CaseDetail';
import Header from './components/Header';
import Footer from './components/Footer';
import FAQ from './pages/FAQ';
import Terms from "./pages/Terms"

const cases = [
  { id: 1, name: 'Малый кейс', image: '/images/test-case.svg', value: 50, color: 'rgba(218, 218, 218, 1)' },
  { id: 2, name: 'Кейс 2', image: '/images/test-case.svg', value: 100, color: 'rgba(118, 150, 234, 1)' },
  { id: 3, name: 'Средний кейс', image: '/images/test-case.svg', value: 500, color: 'rgba(39, 241, 63, 1)' },
  { id: 4, name: 'Средний кейс', image: '/images/test-case.svg', value: 1000, color: 'rgba(39, 84, 242, 1)' },
  { id: 5, name: 'Кейс 3', image: '/images/test-case.svg', value: 1500, color: 'rgba(137, 71, 255, 1)' },
  { id: 6, name: 'Большой кейс', image: '/images/test-case.svg', value: 2500, color: 'rgba(212, 43, 230, 1)' },
  { id: 7, name: 'Большой кейс', image: '/images/test-case.svg', value: 5000, color: 'rgba(248, 55, 55, 1)' },
  { id: 8, name: 'Огромный кейс', image: '/images/test-case.svg', value: 10000, color: 'rgba(255, 182, 25, 1)' },
];

const footerMargin = "74px"; // 61 + 18 + 15 - 20

function MainLayout({ children }) {
  return (
    <>
      <Header />
      <div className="content-wrapper" style={{marginBottom: footerMargin}}>{children}</div>
      <Footer />
    </>
  );
}

function PlainLayoutHeader({ children }) {
  return (
    <>
      <Header />
      <div className="content-wrapper">{children}</div>
    </>
  );
}

function PlainLayoutFooter({ children }) {
  return (
    <>
      <div className="content-wrapper">{children} style={{marginBottom: footerMargin}}</div>
      <Footer />
    </>
  );
}

function PlainLayout({ children }) {
  return (<div className="content-wrapper">{children}</div>);
}

function App() {
  let last = performance.now();
  let frames = 0;
  let fps = 0;

  function loop() {
    const now = performance.now();
    frames++;
    if (now - last >= 1000) {
      fps = frames;
      frames = 0;
      last = now;
      console.log('FPS:', fps);
    }
    requestAnimationFrame(loop);
  }

loop();

  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout><Home cases={cases} /></MainLayout>} />
        <Route path="/case/:id" element={<PlainLayoutHeader><CaseDetail cases={cases} /></PlainLayoutHeader>} />
        <Route path='/earn' element={<MainLayout><Earn /></MainLayout>}></Route>
        <Route path='/profile' element={<MainLayout><Profile /></MainLayout>}></Route>
        <Route path='/faq' element={<PlainLayoutHeader><FAQ /></PlainLayoutHeader>}></Route>
        <Route path='/terms' element={<PlainLayoutHeader><Terms /></PlainLayoutHeader>}></Route>
      </Routes>
    </Router>
  );
}

export default App;
